<template lang="pug">
    div.Result
        lessonHeader
        v-layout.mt-3(row wrap)
            v-flex(xs12, md6)
                imageLoader.Result-image
            v-flex(xs12, md6)
                div.Result-step-title.text-xs-center.text-md-left {{currentStep.title}}
                div.Result-porcentaje.text-xs-center.text-md-left {{result}}/100
                div.Result-button-content.ml-5.ml-sm-0.pl-2.pl-sm-0
                    el-button.Result-button.ml-4.ml-sm-0(type="success" @click="review") Revisar
                div.Result-text.text-xs-center.text-md-left {{currentStep.text}}
                div.Result-p
                  | ¡Muchas felicidades! Todo indica que has adquirido los conocimientos y habilidades más relevantes de Plan de Vida. 
                div.Result-p
                  | ¿Quieres saber más de alguno de los productos que incluiste en tu plan de vida? Conoce:
                div.Result-p
                  |<a class="link" target='_blank' href="https://www.bbva.mx/personas/productos/creditos.html#creditos-hipotecarios">Crédito Hipotecario</a>, <a class="link" target='_blank' href="https://www.bbva.mx/empresas/productos/financiamiento.html">Crédito PyME</a>, <a class="link" target='_blank' href="https://www.bbva.mx/personas/productos/seguros.html">Seguros</a>, <a class="link" target='_blank' href="https://www.bbva.mx/personas/productos/inversion.html">Aprende a Invertir</a> y <a class="link" target='_blank' href="https://www.bbva.mx/empresas/productos/cuentas.html">Emprendimiento</a> 
        buttonNext
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import imageLoader from '@/components/image-loader/image-loader'
import buttonNext from '@/components/button-next/button-next'

export default {
  name: 'Result',
  components:{
	lessonHeader,    
    stepTitle,
    imageLoader,
    buttonNext
  }, 
  computed: {
      ...mapGetters(['currentStep', 'currentGroup']),
      result() {
        let result = 0;
        this.currentGroup.steps.forEach(step => {
          if (step.points) {
            result += step.points;
          }          
        });
        return result;
      }
  },
  methods: {
    ...mapMutations(['setCurrentStep']),
    review() {
      const step = this.currentGroup.steps[this.currentStep.index - 4];
      step.transition = 'slide-back'
      this.setCurrentStep(step);
      //this.currentLesson.review = true;
    }
  },    
}
</script>

<style scoped>
    @import 'result.scss';
</style>

